export function dataURItoBlob(dataURI: string) {
    let byteString = atob(dataURI.split(",")[1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    let bb = new Blob([ab]);
    return bb;
};

// const blob = await createBlobFromFile(file);

export const getObjectURLFromFile = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
            const objectURL = window.URL.createObjectURL(dataURItoBlob(e.target!.result as string)) as string;
            resolve(objectURL);
        };

        reader.onerror = reject;
    });

}